<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-3 flex-wrap">
      <button class="btn btn-light" (click)="goBack()">
        <i class="fa fa-angle-left"></i>
        <span>Back</span>
      </button>

      <h5 class="mb-0 d-flex align-items-center gap-2">
        <span>Stage Details for Master Account:</span>
        <span>{{ master }}</span>
        <span *ngIf="accountName">({{ accountName }})</span>
      </h5>
    </div>

    <button class="btn btn-outline-primary" (click)="load()">
      <i class="fa fa-sync-alt"></i> Refresh
    </button>
  </div>

  <div class="card-body">
    <div class="grid mb-3">
      <p><strong>Process Start:</strong> {{ data?.process?.process_start || 'N/A' }}</p>
      <p><strong>Process End:</strong> {{ data?.process?.process_end || 'N/A' }}</p>
      <p><strong>Total Minutes:</strong> {{ data?.process?.total_minutes || 'N/A' }}</p>
      <p><strong>Total Stages:</strong> {{ data?.process?.total_stages || 'N/A' }}</p>
      <p><strong>Successful Stages:</strong> {{ data?.process?.successful_stages || 'N/A' }}</p>
      <p><strong>Failed Stages:</strong> {{ data?.process?.failed_stages || 'N/A' }}</p>
    </div>
  </div>
</div>

<div class="card-container">
  <div class="card-header">
    <h5>Preprocessing Execution Details</h5>
  </div>
  <div class="card-body stage-table-wrapper">
    <div class="stage-table-scroll">
      <table class="stage-table">
        <thead>
          <tr>
            <th>Stage</th>
            <th>Sub Stage</th>
            <th>Status</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Duration (sec)</th>
            <th>Record Count</th>
            <th>Error Message</th>
            <th>S3 Source Path</th>
            <th>S3 Processed Path</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let stage of processes">
            <td>{{ stage.stage }}</td>
            <td>{{ stage.sub_stage }}</td>
            <td [ngClass]="getStatusClass(stage.stage_status)">
              {{ stage.stage_status }}
            </td>
            <td>{{ stage.start_time }}</td>
            <td>{{ stage.end_time || 'N/A' }}</td>
            <td>{{ stage.duration_sec !== null ? stage.duration_sec : 'N/A' }}</td>
            <td>{{ stage.record_count !== null ? stage.record_count : 'N/A' }}</td>
            <td>{{ stage.error_message || 'N/A' }}</td>
            <td>{{ stage.s3_source_path || 'N/A' }}</td>
            <td>{{ stage.s3_processed_path || 'N/A' }}</td>
          </tr>
          <tr *ngIf="stageDetails.length === 0">
            <td colspan="10">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card-container">
  <div class="card-header">
    <h5>Stage Execution Details for account:</h5>
  </div>

  <div class="card-body stage-table-wrapper">
    <div class="d-flex mb-2">
      <input type="text" class="form-control" placeholder="Search by Account ID" [(ngModel)]="searchTerm"
        (ngModelChange)="searchAccount()" (keyup.enter)="searchAccount()" />
    </div>

    <div class="stage-table-scroll">
      <table class="stage-table table table-bordered">
        <thead>
          <tr>
            <th>Child Account</th>
            <th>Stage Status</th>
            <th>Duration (sec)</th>
            <th>Error Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let acc of pagedStages">
            <td (click)="onAccountClick(acc.accountId)" class="clickable">
              {{ acc.accountId }}
            </td>
            <td>{{ acc.stages_status }}</td>
            <td>{{ acc.stages_duration_sec }}</td>
            <td>{{ acc.Stages_error_message || 'None' }}</td>
          </tr>
          <tr *ngIf="pagedStages.length === 0">
            <td colspan="10" class="text-center">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
        <button class="btn btn-sm me-1 rounded-circle" style="width: 35px; height: 35px; padding: 0;"
          [ngClass]="{ 'btn-primary': currentPage === i + 1, 'btn-outline-primary': currentPage !== i + 1 }"
          (click)="setPage(i + 1)">
          {{ i + 1 }}
        </button>

      </ng-container>
    </div>

  </div>

</div>

<ng-container *ngIf="accountactive">
  <div class="card-container pt-3">
    <div class="selectedac">
      <span>Account: {{account_selected}}</span><i class="fa-solid fa-xmark"
        (click)="accountactive = !accountactive"></i>
    </div>
    <div class="card-header">
      <h5>Processing Execution Details Account Level</h5>
    </div>

    <div class="card-body stage-table-wrapper">
      <div class="stage-table-scroll">
        <table class="stage-table">
          <thead>
            <tr>
              <th>Stage</th>
              <th>Sub Stage</th>
              <th>Status</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Duration (sec)</th>
              <th>Record Count</th>
              <th>Error Message</th>
              <th>S3 Source Path</th>
              <th>S3 Processed Path</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let stage of accountdetails.stages">
              <td>{{ stage.stage }}</td>
              <td>{{ stage.sub_stage }}</td>
              <td [ngClass]="getStatusClass(stage.stage_status)">
                {{ stage.stage_status }}
              </td>
              <td>{{ stage.start_time }}</td>
              <td>{{ stage.end_time || 'N/A' }}</td>
              <td>{{ stage.duration_sec !== null ? stage.duration_sec : 'N/A' }}</td>
              <td>{{ stage.record_count !== null ? stage.record_count : 'N/A' }}</td>
              <td>{{ stage.error_message || 'N/A' }}</td>
              <td>{{ stage.s3_source_path || 'N/A' }}</td>
              <td>{{ stage.s3_processed_path || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>